import React from 'react'

const ReceivableFilter = ({ filters, onFilterChange }) => {
  const [min, setMin] = React.useState(filters.filter?.cash_receivable?.min || '')
  const [max, setMax] = React.useState(filters.filter?.cash_receivable?.max || '')

  const minRef = React.useRef(min)
  const maxRef = React.useRef(max)
  const filtersRef = React.useRef(filters)
  const onFilterChangeRef = React.useRef(onFilterChange)
  const timerRef = React.useRef(null)

  React.useEffect(() => {
    filtersRef.current = filters
    onFilterChangeRef.current = onFilterChange
  }, [filters, onFilterChange])

  const triggerChange = () => {
    if (timerRef.current) clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => {
       onFilterChangeRef.current({ 
         filter: { 
           ...filtersRef.current.filter, 
           cash_receivable: { min: minRef.current, max: maxRef.current } 
         } 
       })
    }, 500)
  }

  const handleMinChange = (e) => {
    const val = e.target.value
    setMin(val)
    minRef.current = val
    triggerChange()
  }

  const handleMaxChange = (e) => {
    const val = e.target.value
    setMax(val)
    maxRef.current = val
    triggerChange()
  }

  return (
    <div className="d-flex flex-column ml-5">
      <span>Receivable</span>
      <div className="d-flex align-items-center">
        <div className="input-group input-group-sm" style={{ width: '80px' }}>
          <div className="input-group-prepend">
            <span className="input-group-text bg-white">$</span>
          </div>
          <input
            type="number"
            className="form-control"
            value={min}
            onChange={handleMinChange}
          />
        </div>
        <span className="mx-2">-</span>
        <div className="input-group input-group-sm" style={{ width: '80px' }}>
          <div className="input-group-prepend">
            <span className="input-group-text bg-white">$</span>
          </div>
          <input
            type="number"
            className="form-control"
            value={max}
            onChange={handleMaxChange}
          />
        </div>
      </div>
    </div>
  )
}

export default ReceivableFilter
